import _styled from '@emotion/styled/base';
import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1y66auy",
  styles: "width:100%;justify-content:center"
} : {
  name: "iultrg-fitCss",
  styles: "width:100%;justify-content:center;label:fitCss;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var fitCss = function fitCss(props) {
  if (props.fit) {
    return _ref;
  }

  return undefined;
};

var ButtonWrapper = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "emkhbpx0"
} : {
  target: "emkhbpx0",
  label: "ButtonWrapper"
})("align-self:center;display:inline-flex;", function (_ref2) {
  var isVertical = _ref2.isVertical;
  return isVertical ? 'flex-direction: column;' : '';
}, ";flex-wrap:nowrap;max-width:100%;position:relative;", fitCss, ";");

export { ButtonWrapper };
